import {Box, Typography, styled, useTheme} from '@mui/material';
import {
  BottomSheet as BtmSheet,
  BottomSheetRef,
  BottomSheetProps,
} from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {Image} from '@jobseeker/lotus/components/Image';
import {CrossOutlined as Cross, WhiteCrossOutlined as WhiteCross} from '@jobseeker/lotus/icons';
const BottomSheet = styled(BtmSheet)<any>(props => ({
  '& [data-rsbs-overlay],[data-rsbs-backdrop]': {
    zIndex: 9999,
  },
  '&::after': {
    zIndex: 9999,
  },
  '& [data-rsbs-header]': {
    ...props.headerStyles,
    overflow: 'hidden',
  },
  '& [data-rsbs-footer]': {
    padding: 0,
    overflow: 'hidden',
    textAlign: 'left',
    border: 'none',
    boxShadow: 'none',
  },
}));

type BottomSheetMapProps = BottomSheetProps & {
  bannerMode?: boolean;
  titleExtension?: string;
};

export default ({children, ...props}: BottomSheetMapProps) => {
  const theme = useTheme();
  return (
    <BottomSheet
      // open={expand}
      // onDismiss={toggleAcordion}
      maxHeight={props?.maxHeight}
      
      snapPoints={({maxHeight, ...other}: any) =>
        [
          maxHeight - maxHeight * 0.1,
          maxHeight - maxHeight * 0.3,
          maxHeight - maxHeight * 0.6,
        ].concat(
          props.snapPoints ? props.snapPoints({maxHeight, ...other}) : []
        )
      }
      defaultSnap={({lastSnap, snapPoints}: any) =>
        lastSnap ?? Math.max(...snapPoints)
      }
      {...props}
      headerStyles={
        props.header
          ? {
              padding: 0,
              textAlign: 'left',
            }
          : props?.bannerMode
          ? {
              background: 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
              borderRadius: '16px 16px 0 0',
              paddingBottom: 16,
            }
          : {}
      }
    >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'default',
            
            paddingBottom: '1px',
          }}
        >
          
          {children}
            
          <Image
            src={props?.bannerMode ? WhiteCross : Cross}
            alt={'Close Icon'}
            width={18}
            height={18}
            
            
            onClick={props.onDismiss}
            objectFit="cover"
            style={{cursor: 'pointer', marginRight:'16px', marginTop:'4px'}}
          />
        </Box>
      
    </BottomSheet>
  );
};
